// Vue
import Vue from "vue";
import App from "./App";
// 多国语
import i18n from "./i18n";
// 菜单和路由设置
import router from "./router";
import menuHeader from "@/menu/header";
import menuAside from "@/menu/aside";
import { frameInRoutes } from "@/router/routes";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
// store
import store from "@/store/index";
// 核心插件
import d2Admin from "@/plugin/d2admin";
import VxeUITable, {VxeUI} from 'vxe-table';
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-table/lib/style.css'
import { formatDate, numFormat, copyUrl, numFormat2,numberFormat } from "@/assets/js/mUtils";
import excel from "@d2-projects/vue-table-export";

import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import moment from "moment";
import horizontalScroll from 'el-table-horizontal-scroll'
import 'vxe-table/lib/index.css'
import 'vxe-pc-ui/lib/style.css'
import { createPinia, PiniaVuePlugin } from 'pinia'

// 设置语言
locale.use(lang);
let echarts = require("echarts");
Vue.prototype.img_host = "https://mwphoto.oss-cn-shenzhen.aliyuncs.com/";
Vue.prototype.formatDate = formatDate;
Vue.prototype.numFormat = numFormat;
Vue.prototype.numFormat2 = numFormat2;
Vue.prototype.copyUrl = copyUrl;
Vue.prototype.echarts = echarts;
Vue.prototype.$moment = moment;
Vue.prototype.numberFormat = numberFormat;
Vue.filter('numberFormat', (v)=>numberFormat(v));
// 核心插件

Vue.use(VxeUIAll)
Vue.use(VxeUITable)
Vue.use(d2Admin);
Vue.use(excel);
Vue.use(PiniaVuePlugin)
// 扩展插件
Vue.use(horizontalScroll)

// 路由就绪后初始化
router.onReady(() => {

  // 初始化固定标签
  store.dispatch("d2admin/tagsView/initAffixTags")

  // 添加当前路由
  const { name, meta } = router.currentRoute
  if (name && !meta?.hidden) {
    store.dispatch("d2admin/tagsView/addView", router.currentRoute)
  }
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
new Vue({
  router,
  store,
  pinia,
  i18n,
  render: (h) => h(App),
  created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit("d2admin/page/init", frameInRoutes);
    // 设置顶栏菜单
    this.$store.commit("d2admin/menu/headerSet", menuHeader);
    // 设置侧边栏菜单
    this.$store.commit("d2admin/menu/asideSet", menuAside);
    // 初始化菜单搜索功能
    this.$store.commit("d2admin/search/init", menuHeader);
  },
  mounted() {
    // 展示系统信息
    this.$store.commit("d2admin/releases/versionShow");
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch("d2admin/account/load");
    // 获取并记录用户 UA
    this.$store.commit("d2admin/ua/get");
    // 初始化全屏监听
    this.$store.dispatch("d2admin/fullscreen/listen");

    // 双重保障：确保当前路由被添加
    const { name, meta } = this.$route
    if (name && !meta?.hidden) {
      this.$store.dispatch("d2admin/tagsView/addView", this.$route)
    }
  },
}).$mount("#app");
